import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';
import { TokenStorageService } from './token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class InvoiceService { 
  baseUrl = environment.baseUrl;

  constructor(
    private router: Router, 
    private http: HttpClient, 
    private tokenStorage: TokenStorageService
  ) { }

  // https://dk90qm7un1jgu.cloudfront.net/api/invoices/list?uuid=4ca12f94-f36a-5b7d-a774-56512585842f
  getInvoices$(uuid: string, page: number): Observable<any> {

    //console.log('uuid'+uuid );
    let url = `${this.baseUrl}${ApiPaths.invoices}`;
    let offset = page * 10;
    return this.http.get<any>(url + 'list?uuid=' + uuid + '&offset=' + offset);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/invoices/list?uuid=4ca12f94-f36a-5b7d-a774-56512585842f
  getInvoicesReceivable$(uuid: string, page: number): Observable<any> {

    //console.log('uuid'+uuid );
    let url = `${this.baseUrl}${ApiPaths.invoices}`;
    let offset = page * 10;
    return this.http.get<any>(url + 'list/receivable?uuid=' + uuid + '&offset=' + offset);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/invoices/?invoice_id=1&uuid=4ca12f94-f36a-5b7d-a774-56512585842f
  getInvoice$(uuid: string, invoiceId: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.invoices}`;
    return this.http.get<any>(url + '?invoice_id=' + invoiceId + '&uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/invoices/?uuid=4ca12f94-f36a-5b7d-a774-56512585842f
  addInvoice$(uuid: string, invoiceInfo: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.invoices}`;
    return this.http.post<any>(url + '?uuid=' + uuid, invoiceInfo, httpOptions);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/invoices/?uuid=4ca12f94-f36a-5b7d-a774-56512585842f
  modifyInvoice$(uuid: string, invoiceId: number, invoiceInfo: any): Observable<any> {
      let url = `${this.baseUrl}${ApiPaths.invoices}`;
      //console.log('edit invoice details', url  );
      return this.http.put<any>(url + '?invoice_id=' + invoiceId + '&uuid=' + uuid, invoiceInfo, httpOptions);
      //return this.http.put<any>(url + invoiceId +'/?uuid=' + uuid, invoiceInfo, httpOptions);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/invoices/?uuid=4ca12f94-f36a-5b7d-a774-56512585842f
  modifyInvoiceJobs$(uuid: string, invoiceId: number, invoiceInfo: any): Observable<any> {
      let url = `${this.baseUrl}${ApiPaths.invoices}`;
      console.log('edit invoice jobs' );
      return this.http.get<any>(url + '?invoice_id=' + invoiceId + '&uuid=' + uuid);
      //return this.http.put<any>(url + invoiceId +'/?uuid=' + uuid, invoiceInfo, httpOptions);
  }

  getInvoiceEmailHistory$(uuid: string, invoiceId: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.invoices}`;
    return this.http.get<any>(url + invoiceId + '/history?uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/invoices/?uuid=4ca12f94-f36a-5b7d-a774-56512585842f
  modifyInvoicePayments$(uuid: string, invoiceId: number, invoiceInfo: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.invoices}`;
    console.log('edit invoice payments' );
    return this.http.get<any>(url + '?invoice_id=' + invoiceId + '&uuid=' + uuid);
    //return this.http.put<any>(url + invoiceId +'/?uuid=' + uuid, invoiceInfo, httpOptions);
  }

  searchInvoice$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.invoices}`;
    let offset = page * 10;
    return this.http.get<any>(url + 'search?query=' + search + '&uuid=' + uuid + '&offset=' + offset);
  }
  //export invoice for print
  exportInvoicePrint$(uuid: string, invoiceId: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.invoices}`;
    console.log(url + invoiceId + '/export/html?uuid=' + uuid);
    return this.http.get<any>(url + invoiceId + '/export/html?uuid=' + uuid, httpOptions);
  }

  //export invoice for email
  exportInvoiceEmail$(uuid: string, invoiceId: number, recipients:any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.invoices}`;
    return this.http.post<any>(url + invoiceId + '/export/email?uuid=' + uuid, {recipients: recipients}, httpOptions);
  }
  
  getInvoiceListStatus$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'status?uuid=' + uuid);
  }
  
}